import React from 'react';
import { Box, Container, Typography } from '@mui/material';
import { Grid } from '@mui/material';

import LazyImage from '../../../Layouts/LazyImage';

import style from './style';

const HighlightProject = ({ data }) => {
  const classes = style();

  return (
    <Box py={1} textAlign="center" position="relative" color="#fff">
      <Container className={classes.mainContainer}>
        <Box width="100%">
          <Grid container justifyContent="center">
            <Grid item xs={12} sm={8}>
              {data?.para.map((para, key) => (
                <Typography key={key} variant="h4" gutterBottom component="h2">
                  {para}
                </Typography>
              ))}
            </Grid>
          </Grid>
        </Box>

        <Typography
          className={classes.captionText}
          align="right"
          variant="body2"
        >
          {data?.by}
        </Typography>
      </Container>
      <Box className={classes.overlap} />
      <LazyImage
        className={classes.bgImage}
        src={`/images/courses/project/b1_jason_anchor_1.jpg`}
      />
    </Box>
  );
};

export default HighlightProject;
